<script setup lang="ts">
import { nextTick, watch } from 'vue'
import QRCode from 'qrcode'

const props = defineProps<{
  show: boolean
  code: string
}>()

const emit = defineEmits<{
  'update:show': [value: boolean]
}>()

const close = () => {
  emit('update:show', false)
}

// Watch para generar QR cuando cambia el código o se abre el modal
const updateQR = async () => {
  if (props.code && props.code.length > 100) {
    nextTick(async () => {
      setTimeout(async () => {
        const qrContainer = document.getElementById('qr-modal-container')
        if (qrContainer) {
          qrContainer.innerHTML = ''
          try {
            const canvas = await QRCode.toCanvas(props.code, {
              width: 350,
              margin: 1,
              color: {
                dark: '#000000',
                light: '#FFFFFF'
              },
              errorCorrectionLevel: 'L',
              version: 40  // Maximum version for largest QR codes
            })
            qrContainer.appendChild(canvas)
          } catch (err) {
            console.error('Error generating QR in modal:', err)
          }
        }
      }, 50)
    })
  }
}

// Watch cuando cambia el código
watch(() => props.code, updateQR)

// Watch cuando se abre/cierra el modal
watch(() => props.show, (show) => {
  if (show) {
    updateQR()
  }
})
</script>

<template>
  <div v-if="show" @click.self="close" class="fixed inset-0 bg-white flex flex-col items-center justify-center z-50 p-6">
    <button @click="close" class="absolute top-4 right-4 text-gray-800 text-3xl hover:scale-110 transition-transform z-10">✕</button>
    <div class="text-center">
      <h2 class="text-2xl font-bold text-gray-800 mb-6">Escanea este código QR</h2>
      <div id="qr-modal-container" class="flex justify-center items-center bg-white p-6 rounded-2xl">
        <!-- QR se generará aquí dinámicamente -->
      </div>
      <p class="text-gray-600 mt-6 text-sm">Toca fuera o en ✕ para cerrar</p>
    </div>
  </div>
</template>
